import { render, staticRenderFns } from "./MostrarDatosDispositivos.vue?vue&type=template&id=05e28a0d&scoped=true"
import script from "./MostrarDatosDispositivos.vue?vue&type=script&setup=true&lang=js"
export * from "./MostrarDatosDispositivos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MostrarDatosDispositivos.vue?vue&type=style&index=0&id=05e28a0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e28a0d",
  null
  
)

export default component.exports